import { render, staticRenderFns } from "./Homebuying.vue?vue&type=template&id=b3f797d8&scoped=true&"
import script from "./Homebuying.vue?vue&type=script&lang=js&"
export * from "./Homebuying.vue?vue&type=script&lang=js&"
import style0 from "./Homebuying.vue?vue&type=style&index=0&id=b3f797d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f797d8",
  null
  
)

export default component.exports